import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, Button, Paper } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const NotFound = () => {
  const navigate = useNavigate();

  const handleGoToLogin = () => {
    // Clear all auth data before navigating
    localStorage.removeItem("user");
    localStorage.removeItem("adminToken");
    localStorage.removeItem("adminUser");
    localStorage.removeItem("hasEverConnected");
    
    // Clear access token from memory
    try {
      const { clearAccessToken } = require("../../utils/tokenManager");
      clearAccessToken();
    } catch (e) {
      console.log("Could not clear access token:", e);
    }
    
    // Navigate to login
    navigate("/", { replace: true });
    // Force reload to ensure clean state
    window.location.href = "/";
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundColor: "#f5f5f5",
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          maxWidth: 500,
          width: "100%",
        }}
      >
        <ErrorOutlineIcon sx={{ fontSize: 80, color: "error.main", mb: 2 }} />
        <Typography variant="h4" component="h1" gutterBottom>
          Page Not Found
        </Typography>
        <Typography variant="body1" align="center" sx={{ mb: 3 }}>
          The account you're trying to access does not exist, or the ID is
          invalid. Please go back to login.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          size="large"
          onClick={handleGoToLogin}
        >
          Go to Login
        </Button>
      </Paper>
    </Box>
  );
};

export default NotFound;
